$(function () {
  //start the slider
  $(".slick-carousel").slick({
    slidesToShow: 3,
    infinite: true,
    autoplay: true,
    centerMode: true,
    variableWidth: false,
    centerPadding: "260px",
    speed: 400,
    arrows: true,
    focusOnSelect: true,
    dots: false,
    prevArrow:
      '<button class="custom-prev"><svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2L2 11L11 20" stroke="white" stroke-width="3" stroke-linejoin="round"/></svg></button>',
    nextArrow:
      '<button class="custom-next"><svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L11 11L2 20" stroke="white" stroke-width="3" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
    ],
  });
});
